export const IS_SIGNED = "IS_SIGNED";
export const IS_SIGNED_TOKEN = "IS_SIGNED_TOKEN";
export const AUTH_START = "AUTH_START";
export const IS_NEWACCOUNT = "IS_NEWACCOUNT";
export const LOG_OUT = "LOG_OUT";
export const IS_ERROR_LOGIN = "IS_ERROR_LOGIN";
export const IS_ERROR_ACCOUNT = "IS_ERROR_ACCOUNT";
export const RESET_ERROR = "RESET_ERROR";
export const CREATE_USER = "CREATE_USER";
export const ORDER_VISIBLE = "ORDER_VISIBLE";
export const SETTINGS_ACCOUNT_VISIBLE = "SETTINGS_ACCOUNT_VISIBLE";
export const CHANGE_EMAIL_VISIBLE = "CHANGE_EMAIL_VISIBLE";
export const SPINNER = "SPINNER";
export const LOGIN_VISIBLE = "LOGIN_VISIBLE";
export const REGISTRATION_VISIBLE = "REGISTRATION_VISIBLE";
export const MENU_VISIBLE = "MENU_VISIBLE";
export const ERROR_NETWORK = "ERROR_NETWORK";
export const RESET_PASSWORD_VISIBLE = "RESET_PASSWORD_VISIBLE";
export const ERROR_RESET_PASSWORD = "ERROR_RESET_PASSWORD";
export const REGISTRATION_VALIDATION_CHANGE = "REGISTRATION_VALIDATION_CHANGE";
export const LOGIN_VALIDATION_CHANGE = "LOGIN_VALIDATION_CHANGE";
export const DELETE_ACCOUNT_CONFIRM = "DELETE_ACCOUNT_CONFIRM";
export const DELETE_ACCOUNT = "DELETE_ACCOUNT";
export const CHANGE_EMAIL = "CHANGE_EMAIL";
export const CHANGE_EMAIL_BUSY = "CHANGE_EMAIL_BUSY";
export const CHANGE_PASSWORD_VISIBLE = "CHANGE_PASSWORD_VISIBLE";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const BAD_PASSWORD = "BAD_PASSWORD";
export const INITIATE_LOG_OUT = "INITIATE_LOG_OUT";
/////////////////////////////END AUTH///////////////////////////////////

export const SAVE_ALL_DISPATCH_ARRAY = "SAVE_ALL_DISPATCH_ARRAY";
export const ORDER_ACCEPT = "ORDER_ACCEPT";
export const ORDER_VALUE = "ORDER_VALUE";
export const BUY_BOOL = "BUY_BOOL";
export const BUY_TIMEOUT = "BUY_TIMEOUT";
export const REFS_ADD = "REFS_ADD";
export const USER_ORDERS = "USER_ORDERS";

/////////////////////////////AUTH///////////////////////////////////
/////////////////////////////SAGA///////////////////////////////////
export const LOG_OUT_SAGA = "LOG_OUT_SAGA";
export const CHECK_TIMEOUT_SAGA = "CHECK_TIMEOUT_SAGA";
export const AUTH_SAGA = "AUTH_SAGA";
export const AUTH_CHECK_STATE_SAGA = "AUTH_CHECK_STATE_SAGA";
export const AUTH_CHECK_PASSWORD_SAGA = "AUTH_CHECK_PASSWORD_SAGA";
export const ON_AUTH_RESET_PASSWORD_SAGA = "ON_AUTH_RESET_PASSWORD_SAGA";
export const DELETE_ACCOUNT_SAGA = "DELETE_ACCOUNT_SAGA";
export const CHANGE_EMAIL_SAGA = "CHANGE_EMAIL_SAGA";
export const CHANGE_PASSWORD_SAGA = "CHANGE_PASSWORD_SAGA";
/////////////////////////////END AUTH///////////////////////////////////
export const GET_DISABLED_DATA_SAGA = "GET_DISABLED_DATA_SAGA";
export const GET_ORDER_SAGA = "GET_ORDER_SAGA";
export const ADD_NEW_DISABLED_DATA_SAGA = "ADD_NEW_DISABLED_DATA_SAGA";
export const ADD_NEW_ORDER_SAGA = "ADD_NEW_ORDER_SAGA";
export const ADD_NEW_ORDER_REDUCER = "ADD_NEW_ORDER_REDUCER";
